import PropTypes from 'prop-types';
import * as React from 'react';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const propTypes = {
    ratingValue: PropTypes.number.isRequired,
    starsToShow: PropTypes.number,
    skin: PropTypes.oneOf([
        'standard',
        'monochromatic'
    ])
};
const RatingsStars = createComponent({
    displayName: 'RatingsStars',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const classesSet = new Set([
                'swan-ratings'
            ]);
            if (props.skin && props.skin !== 'standard') classesSet.add(`swan-ratings-skin-${props.skin}`);
            return classesSet;
        },
        processProps (props) {
            return _object_spread({
                role: 'img'
            }, props);
        },
        wrapChildren ({ ratingValue , starsToShow  }) {
            const [ratingInteger, ratingFractional] = ratingValue.toFixed(1).split('.').map((u)=>Number(u)) // Normalizing to one decimal place
            ;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, Array.from(Array(starsToShow).keys()).map((u, idx)=>{
                const ratingClasses = [
                    'swan-ratings-star'
                ];
                if (idx + 1 <= ratingInteger) ratingClasses.push('swan-ratings-star-filled');
                if ((ratingFractional && idx + 1) === ratingInteger + 1) ratingClasses.push(`swan-ratings-star-filled-p${ratingFractional}`);
                return /*#__PURE__*/ React.createElement("span", {
                    key: `star_${u}`,
                    className: ratingClasses.join(' ')
                });
            }));
        }
    }
});
RatingsStars.defaultProps = {
    ratingValue: 0,
    starsToShow: 5
};

export { RatingsStars };
